import script from "./docTags.vue?vue&type=script&setup=true&lang=js"
export * from "./docTags.vue?vue&type=script&setup=true&lang=js"

import "./docTags.vue?vue&type=style&index=0&id=179777ca&scoped=true&lang=css"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-179777ca"]])

export default __exports__